import styled, { keyframes } from 'styled-components'

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`

export const Loader = styled.span`
  animation: ${rotation} 1s linear infinite;
  border-radius: 50%;
  border-right: 4px solid transparent;
  border-top: 4px solid #e10719;
  box-sizing: border-box;
  display: inline-block;
  height: 48px;
  width: 48px;

  &::after {
    animation: ${rotation} 0.5s linear infinite reverse;
    border-bottom: 4px solid transparent;
    border-left: 4px solid #e10719;
    border-radius: 50%;
    box-sizing: border-box;
    content: '';
    height: 48px;
    left: 0;
    position: absolute;
    top: 0;
    width: 48px;
  }
`
